function initCarousel(root) {
  const track = root.querySelector('[data-raw-test2-track]');
  const slides = Array.from(root.querySelectorAll('[data-raw-test2-slide]'));
  const prevButton = root.querySelector('[data-raw-test2-prev]');
  const nextButton = root.querySelector('[data-raw-test2-next]');
  const dots = Array.from(root.querySelectorAll('[data-raw-test2-dot]'));
  if (!track || slides.length === 0) return;

  function activeIndex() {
    const trackRect = track.getBoundingClientRect();
    let closest = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackRect.left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function updateDots() {
    const index = activeIndex();
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  }

  function goTo(index) {
    const clamped = Math.max(0, Math.min(index, slides.length - 1));
    slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  prevButton?.addEventListener('click', () => goTo(activeIndex() - 1));
  nextButton?.addEventListener('click', () => goTo(activeIndex() + 1));

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goTo(index));
  });

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateDots, 100);
  });

  updateDots();
}

document.querySelectorAll('[data-raw-test2-carousel]').forEach(initCarousel);
